import Vue from 'vue'

const state = {
}

const getters = {
    status2variant(state) {
        return (status) => {
            const table = {
                'saved': 'dark',
                'paid': 'dark',
                'shipped': 'success',
                'canceled': 'success',
                //'listed': 'info',
                //'sold': 'danger',
                //'': 'warning',
            }
            return table[status]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/shippings' + (data.uuid ? '/' + data.uuid : ''), data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })

//        const response = await axios.post('/api/v1/shippings' + (data.id ? '/' + data.id : ''), data)
//            .catch(error => error.response || null)
//        return response
    },
    async destroy (context, data) {
        if (data.id === undefined) {
            return {
                data: {
                    data: {
                    },
                },
            }
        }
        const response = await axios.delete('/api/v1/shippings/' + data.id)
            .catch(error => error.response || null)
        return response
    },
    async index (context, data) {
        const response = await axios.get('/api/v1/shippings' + (typeof data  === 'string' ? '/' + data : ''), {
            params: (typeof data === 'object' ? data : null)
        })
        .catch(error => error.response || null)
        return response
    },
    async status (context, data) {
        const response = await axios.put('/api/v1/shippings/' + data.uuid + '/status', data)
            .catch(error => error.response || null)
        return response
    },
    async download (context, data) {
        data = Object.assign(data, { download: true, })
        const response = await axios.get('/api/v1/shippings', {
            params: (typeof data === 'object' ? data : null),
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        Vue.prototype.download(response)
        return response
    },
    async list_item (context, data) {
        const response = await axios.post('/api/v1/shippings/' + data.uuid + '/list_item/' + data.provider, data)
            .catch(error => error.response || null)

        return response
    },
    async fetch_fulfillment_order (context, data) {
        data = Object.assign(data)
        const response = await axios.get('/api/v1/shippings/fetch_fulfillment_order', {
            params: {
                order_user_id: data.order_user_id,
                provider_type: data.provider_type,
                order_id: data.order_id,
            },
        })
        .catch(error => error.response || null)
        return response
    },
    async fetch_fulfillment_orders (context, data) {
        data = Object.assign(data)
        const response = await axios.get('/api/v1/shippings/fetch_fulfillment_orders', {
            params: {
                order_user_id: data.order_user_id,
                provider_type: data.provider_type,
                order_type: data.order_type,
                order_query: data.order_query,
                order_shipped: data.order_shipped || '1',
            },
        })
        .catch(error => error.response || null)
        return response
    },
    async fetch_orders (context, data) {
        data = Object.assign(data)
        const response = await axios.get('/api/v1/shippings/fetch_orders', {
            params: {
                order_user_id: data.order_user_id,
                provider_type: data.provider_type,
                order_type: data.order_type,
                order_query: data.order_query,
                order_shipped: data.order_shipped || '1',
            },
        })
        .catch(error => error.response || null)
        return response
    },
    async ship_orders (context, data) {
        data = Object.assign(data)
        const response = await axios.post('/api/v1/shippings/'+data.shipping_id+'/ship_orders', data)
            .catch(error => error.response || null)
        return response
    },
    async rate (context, data) {
        data = Object.assign(data)
        return axios.post('/api/v1/shippings/rate', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async rate_ecms (context, data) {
        data = Object.assign(data)
        return axios.post('/api/v1/shippings/rate_ecms', data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async print (context, data) {
        data = Object.assign(data)
        return axios.get('/api/v1/shippings/print', {
//        const response = await axios.get('/api/v1/shippings/print', {
            params: data,
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
            .then((response) => {
                Vue.prototype.download(response)
                return response
            })
            .catch((error) => {
                return Promise.reject(error || {})
            })
//
//
//        .catch(error => error.response || null)
//        Vue.prototype.download(response)
//        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

